// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { quickOrderSearchStyles } from "@steiner/Overrides/Widgets/QuickOrder/QuickOrderSearch";
import AlertInfo from "@steiner/XDL/Icons/AlertInfo";
import { color, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

quickOrderSearchStyles.productSelector = {
    container: {
        gap: 16,
    },
    searchGridItem: {
        width: [12, 6, 5, 5, 5],
    },
    actionsGridItem: {
        width: [12, 6, 7, 7, 7],
        css: css`
            gap: 16px;
            align-items: flex-end;
        `,
    },
    selectButton: {
        css: css`
            ${xScreen("lt", "sm")} {
                width: 100%;
            }
        `,
    },
    clearIcon: {
        size: 16,
        color: "common.ui1",
        css: css`
            top: 41px;
            right: 45px;
            border-radius: 50%;
            background: ${color("primary")};
            padding: 2px;
        `,
    },
};

quickOrderSearchStyles.labelWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        align-items: center;
    `,
};

quickOrderSearchStyles.tooltip = {
    iconProps: {
        color: "primary",
        src: AlertInfo,
    },
};
